import { useCallback, useMemo, useState } from "react";
import type { FilaProductoCotizado } from "../types/cotizacionProveedores.types";

export type SeleccionProductos = Record<number, string>; // id_inventario -> idDetalle

export const esSeleccionable = (p: FilaProductoCotizado): boolean =>
    p.gestionado === 1 && p.disponibilidad === 1 && p.seleccionado !== 2 && p.seleccionado !== 3;

export const obtenerEstatusProducto = (
    esComputo: boolean
): Record<number, { label: string; color: string }> => ({
    0: { label: "PENDIENTE", color: "#9e9e9e" },
    1: { label: "SELECCIONADO", color: "#1d80c2" },
    2: { label: "NO AUTORIZADO POR DG", color: "#bd0606" },
    3: { label: esComputo ? "AUTORIZADO" : "COTIZADO", color: "#1dad76" },
});

export const useSeleccionProductos = () => {
    const [seleccion, setSeleccion] = useState<SeleccionProductos>({});

    const alternar = useCallback((p: FilaProductoCotizado) => {
        setSeleccion((prev) => {
            const actual = prev[p.idInventario];
            if (actual === p.id) {
                const { [p.idInventario]: _, ...resto } = prev;
                return resto;
            }
            if (actual !== undefined) return prev;
            return { ...prev, [p.idInventario]: p.id };
        });
    }, []);

    const limpiar = useCallback(() => setSeleccion({}), []);

    const idsDetalle = useMemo(() => Object.values(seleccion).map(Number), [seleccion]);

    return { seleccion, alternar, limpiar, idsDetalle };
};